<template>
  <div class="pagination">
    <button class="pagination__arrow pagination__arrow--left" :disabled="isBeginning" @click="prevPage()"></button>
    <div class="pagination__items">
      <button
        class="pagination__item pagination__item--number"
        :class="currentPage === index + 1 ? 'pagination__item--active' : ''"
        v-for="index in pagesArray"
        :key="index"
        @click="setCurrentPage(index + 1)"
      >{{ getButtonNumber(index + 1) }}</button>
    </div>
    <button class="pagination__arrow pagination__arrow--right" :disabled="isEnd" @click="nextPage()"></button>
  </div>
</template>

<script>
import '@/assets/sass/pagination.sass';

export default {
  name: 'PagePagination',
  props: {
    initial: {
      default: () => 1,
      type: Number,
    },
    pages: {
      default: () => 1,
      type: Number,
    },
  },
  data() {
    return {
      currentPage: this.initial,
    };
  },
  computed: {
    pagesArray() {
      return [...Array(this.pages).keys()];
    },
    isBeginning() {
      return this.currentPage === 1;
    },
    isEnd() {
      return this.currentPage === this.pages;
    },
  },
  methods: {
    getButtonNumber(num) {
      return num < 10 ? `0${num}` : num;
    },
    setCurrentPage(page) {
      this.currentPage = page;
      this.$emit('changePage', page);
    },
    nextPage() {
      if (this.currentPage === this.pages) return;
      this.setCurrentPage(this.currentPage + 1);
    },
    prevPage() {
      if (this.currentPage === 1) return;
      this.setCurrentPage(this.currentPage - 1);
    },
  },
};
</script>
